import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Phone, WhatsappLogo, Lightning, CalendarBlank } from "@phosphor-icons/react";
import { COMPANY } from "@/seo/data";

export const InlineCTA = ({ variant = "default" }) => (
  <div className={`not-prose rounded-2xl border p-6 sm:p-8 my-8 ${variant === "dark" ? "bg-slate-900 border-slate-800 text-white" : "bg-blue-50 border-blue-100"}`}>
    <h3 className={`text-2xl font-bold tracking-tight ${variant === "dark" ? "text-white" : "text-slate-900"}`}>
      Schaden jetzt in 5 Minuten online melden
    </h3>
    <p className={`mt-2 ${variant === "dark" ? "text-slate-300" : "text-slate-700"}`}>
      Termin innerhalb 24 Stunden · Direkt mit Ihrer Versicherung abgerechnet · Sie kümmern sich um nichts.
    </p>
    <div className="mt-5 flex flex-wrap gap-3">
      <Button asChild className="h-12 bg-blue-600 hover:bg-blue-700 text-white">
        <Link to="/schaden-melden" data-testid="cta-report"><Lightning size={18} className="mr-2" />Schaden melden</Link>
      </Button>
      <Button asChild variant="outline" className={`h-12 ${variant === "dark" ? "bg-transparent border-slate-700 text-white hover:bg-slate-800" : ""}`}>
        <Link to="/schaden-melden" data-testid="cta-book"><CalendarBlank size={18} className="mr-2" />Termin buchen</Link>
      </Button>
      <a href={`https://wa.me/${COMPANY.whatsapp}`} target="_blank" rel="noreferrer"
        className="inline-flex items-center justify-center h-12 px-5 rounded-md bg-emerald-600 hover:bg-emerald-700 text-white font-medium transition-colors" data-testid="cta-whatsapp">
        <WhatsappLogo size={18} className="mr-2" weight="fill" />WhatsApp
      </a>
      <a href={`tel:${COMPANY.phone}`} className={`inline-flex items-center justify-center h-12 px-5 rounded-md font-medium transition-colors ${variant === "dark" ? "bg-white text-slate-900 hover:bg-slate-100" : "bg-slate-900 text-white hover:bg-slate-800"}`} data-testid="cta-call">
        <Phone size={18} className="mr-2" weight="fill" />{COMPANY.phone_display}
      </a>
    </div>
  </div>
);

export default InlineCTA;
